var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.auctionObj.is_paused)?_c('div',{staticClass:"alert alert-warning ta-auction-pause",domProps:{"innerHTML":_vm._s(_vm.pauseMessage)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }